import { render } from "./Checklist.vue?vue&type=template&id=6986838a&ts=true"
import script from "./Checklist.vue?vue&type=script&lang=ts"
export * from "./Checklist.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__